import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TicketList from '../../components/TicketSystem/TicketList';
import TicketStats from '../../components/TicketSystem/TicketStats';

const Tickets = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('list');

  useEffect(() => {
    if (searchParams.get('status')) {
      setActiveTab('list');
    }
  }, [searchParams]);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Ticket Management</h1>
        <p className="text-gray-600 mt-2">Manage and track support tickets across the platform</p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6">
        <nav className="flex space-x-8">
          <button
            onClick={() => setActiveTab('list')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'list'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            All Tickets
          </button>
          <button
            onClick={() => setActiveTab('stats')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'stats'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Statistics
          </button>
        </nav>
      </div>

      {/* Content */}
      <div>
        {activeTab === 'list' && <TicketList />}
        {activeTab === 'stats' && <TicketStats />}
      </div>
    </div>
  );
};

export default Tickets; 